import { Home, Users } from "lucide-react";

export default function Header() {
  return (
    <header className="bg-white border-b border-slate-200 px-6 md:px-12 lg:px-24 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo and Brand */}
        <div className="flex items-center gap-4">
          <img 
            src="/elevatex-logo.jpg" 
            alt="ElevateX Solutions" 
            className="h-12 w-12 object-contain"
          />
          <div className="flex flex-col">
            <h1 className="text-xl font-bold text-[#0F172A]">ElevateX Solutions</h1>
            <p className="text-sm text-[#64748B]">Resume Evaluation Tool</p>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex items-center gap-4">
          <button
            onClick={() => window.location.href = 'https://elevatex.solutions'}
            className="flex items-center gap-2 px-4 py-2 rounded-md hover:bg-slate-100 transition-colors"
            data-testid="home-button"
          >
            <Home className="w-4 h-4" />
            <span className="hidden sm:inline">Home</span>
          </button>
          
          <button
            onClick={() => window.open('https://elevatex.solutions/hiring', '_blank')}
            className="flex items-center gap-2 px-4 py-2 border-2 border-[#2563EB] text-[#2563EB] hover:bg-[#2563EB] hover:text-white rounded-md transition-colors"
            data-testid="hiring-button"
          >
            <Users className="w-4 h-4" />
            <span className="hidden sm:inline">Open Positions</span>
          </button>
        </nav>
      </div>
    </header>
  );
}